import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useOrganization } from '../../hooks/useOrganization';
import { OrganizationSetup } from '../dashboard/OrganizationSetup';
import { ROUTES } from '../../config/constants';

export function OnboardingPage() {
  const { session } = useAuth();
  const { hasOrganization, loading } = useOrganization();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login if not authenticated
    if (!session && !loading) {
      navigate(ROUTES.LOGIN);
      return;
    }

    // Redirect to dashboard if user already has an organization
    if (hasOrganization && !loading) {
      navigate(ROUTES.DASHBOARD);
      return;
    }
  }, [session, hasOrganization, loading, navigate]);

  // Show loading state while checking organization status
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-muted-foreground">Setting up your workspace...</p>
        </div>
      </div>
    );
  }

  // Show organization setup if user doesn't have an organization
  if (!hasOrganization) {
    return <OrganizationSetup />;
  }

  // This shouldn't happen, but just in case
  return null;
} 